import isEqual from 'lodash.isequal';

export const useSceneUtils = () => {
  const isSceneModified = (current, saved) => {
    // If we don't have a saved baseline yet, be safe and assume modified.
    // This prevents losing changes when the snapshot hasn't finished syncing.
    if (!saved) return true;

    const normalizeParent = (p) => {
      if (p == null) return null;
      if (typeof p === 'string' || typeof p === 'number') return p;
      if (typeof p === 'object') {
        return (
          p.name ||
          p.url ||
          p._id ||
          p.id ||
          p.temp_file_name ||
          null
        );
      }
      return null;
    };

    const normalizeObjects = (arr = []) =>
      arr
        .map((obj) => ({
          name: obj.name || '',
          events: obj.events,
          type: obj.type || '',
          url: obj.url || obj.name || '',
          parent: normalizeParent(obj.parent),
          position: Array.isArray(obj.position)
            ? [...obj.position]
            : obj.position?.toArray?.() || [0, 0, 0],
          rotation: Array.isArray(obj.rotation)
            ? [...obj.rotation]
            : obj.rotation
              ? [obj.rotation.x, obj.rotation.y, obj.rotation.z]
              : [0, 0, 0],
          scale: Array.isArray(obj.scale)
            ? [...obj.scale]
            : obj.scale?.toArray?.() || [1, 1, 1],
          userData: obj.userData,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));

    const normalizeParticles = (arr = []) =>
      arr
        .map((particle) => ({
          id: particle.id,
          name: particle.name || '',
          parent: normalizeParent(particle.parent),
          count: particle.count,
          size: particle.size,
          opacity: particle.opacity,
          speed: particle.speed,
          lifetime: particle.lifetime,
          position: particle.position,
          scale: particle.scale,
          rotation: particle.rotation,
          animation: particle.animation,
          animationDuration: particle.animationDuration,
          color: particle.color,
          texture: particle.texture,
          shape: particle.shape,
          gravity: particle.gravity,
          wind: particle.wind,
          noise: particle.noise,
          emission: particle.emission,
          blending: particle.blending,
        }))
        .sort((a, b) => (a.id || '').localeCompare(b.id || ''));

    const normalizeScene = (scene) => ({
      meshes: normalizeObjects(scene.meshes),
      hotspots: normalizeObjects(scene.hotspots || []),
      images: normalizeObjects(scene.images),
      videos: normalizeObjects(scene.videos),
      audios: normalizeObjects(scene.audios),
      text: normalizeObjects(scene.text),
      Light: normalizeObjects(scene.Light),
      particles: normalizeParticles(scene.particles),
    });

    const currentNormalized = normalizeScene(current);
    const savedNormalized = normalizeScene(saved);
    return !isEqual(currentNormalized, savedNormalized);
  };

  return {
    isSceneModified,
  };
};
